<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <div
    class="border-current inline-block size-16 animate-spin rounded-full border-4 border-solid border-e-primary-100 align-[-0.125em] text-black-10 motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
    role="status"
  >
    <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0">Loading...</span>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.loader {
  width: 70px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, currentColor 94%, #0000) top/5px 5px no-repeat,
    conic-gradient(#0000 30%, currentColor);
  animation: l13 1s infinite linear;
}
@keyframes l13 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
